const groupPrefix = createApiRoute(
	ApiModule.PRODUCTION_PLANNING,
	ApiAuthorization.EMPLOYEE,
	ApiDataModel.PRODUCTION_STAGES,
)

export const apiProductionStages = {
	fetchStageMachineTypes: async (
		stageId: number,
	): Promise<IApiResponseModel<IProductionSocketBasicMachineTypeModel[]>> => {
		const { data } = await apiCommon<IProductionSocketBasicMachineType[]>(
			`${groupPrefix}/${stageId}/machine-types`,
			{
				method: 'GET',
			},
		)

		return { data: data.map(ProductionSocketBasicMachineType) }
	},

	fetchStageMachines: async (
		stageID: number,
	): Promise<IApiResponseModel<IProductionSimulationPositionMachineModel[]>> => {
		const { data } = await apiCommon<IProductionSimulationPositionMachine[]>(`${groupPrefix}/${stageID}/machines`, {
			method: 'GET',
		})

		return { data: data ? data.map(d => ProductionSimulationPositionMachine(d)) : [] }
	},
}
